<template>
    <div>
        <button class="d-none" @click="openPostModal()" id="openAbsenceModal">new</button>
        <button class="d-none" @click="editAbsence()" id="editAbsenceModal">edit</button>

        <div class="modal fade" id="postAbsenceModal" tabindex="-1" aria-labelledby="postAbsenceModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ form.id == null ? 'Nouvelle' : 'Modification' }} demande d'absence</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12" v-show="form.id == null">
                                <div class="form-group">
                                    <label for="identityAutocomplete">Salarié</label>
                                    <input class="form-control" type="text" v-model="form.identity"
                                        id="identityAutocomplete" :disabled="!canApprove && !canValid">
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="absence-type">Type</label>
                                    <select id="absence-type" class="form-control" v-model="form.type">
                                        <option :value="type.value" v-for="(type, index) in types">{{ type.label }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6">
                                <div class="form-group">
                                    <label for="absence_start_at">Du</label>
                                    <input type="text" class="form-control datepicker" placeholder="jj/mm/aaaa"
                                        id="absence_start_at" v-model="form.start_at" data-set-min="absence_end_at">

                                    <select id="" class="form-control mt-2" v-model="form.start_moment">
                                        <option value="1">Matin</option>
                                        <option value="2">Après-midi</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6">
                                <div class="form-group">
                                    <label for="absence_end_at">Au (inclus)</label>
                                    <input type="text" class="form-control datepicker" placeholder="jj/mm/aaaa"
                                        id="absence_end_at" v-model="form.end_at" data-set-max="absence_start_at">

                                    <select id="" class="form-control mt-2" v-model="form.end_moment">
                                        <option value="1">Matin</option>
                                        <option value="2">Après-midi</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <div class="form-group">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="absence-exclude-saturdays"
                                            value="1" v-model="form.exclude_saturdays">
                                        <label class="custom-control-label" for="absence-exclude-saturdays">Exclure les
                                            samedis</label>
                                    </div>

                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="absence-exclude-sundays"
                                            value="1" v-model="form.exclude_sundays">
                                        <label class="custom-control-label" for="absence-exclude-sundays">Exclure les
                                            dimanches</label>
                                    </div>

                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                            id="absence-exclude-public-holidays" value="1"
                                            v-model="form.exclude_public_holidays">
                                        <label class="custom-control-label" for="absence-exclude-public-holidays">Exclure
                                            les jours fériés</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="description">Description</label>
                                    <textarea name="description" id="description" rows="4" class="form-control"
                                        v-model="form.description"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="submit" class="ix-btn green" v-bind:disabled="!checkForm() || loadingForm"
                            @click="post()">
                            <span v-if="!loadingForm">Enregistrer</span>
                            <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <button class="d-none" @click="openAbsence()" id="openShow" data-absence="">open</button>

        <div class="modal fade" id="showAbsenceModal" tabindex="-1" aria-labelledby="showAbsenceModal" aria-hidden="true">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div v-if="selectedAbsence && selectedUser && !loadingShow">
                        <div class="modal-body">

                            <div class="ix-absence-card-header">
                                <span class="ix-avatar">
                                    <img :src="selectedUser.avatar_path" v-if="selectedUser.avatar_path">
                                    <span v-if="!selectedUser.avatar_path">{{ selectedUser.initial }}</span>
                                </span>

                                <span class="ix-absence-card-fullname">{{ selectedUser.fullname }}</span>
                                <div class="ix-absence-card-type">
                                    <span class="ix-absence-type-preview-color"
                                        v-bind:style="{ background: selectedAbsence.color }"></span> {{
                                            selectedAbsence.type_label }}
                                </div>

                                <span class="ix-state">{{ selectedAbsence.state_label }}</span>

                                <div class="ix-absence-card-date mt-4">
                                    Du {{ selectedAbsence.start_at | formatDate('DD MMMM YYYY') }} - {{
                                        selectedAbsence.start_moment == 1 ? 'matin' : 'après-midi' }}
                                </div>
                                <div class="ix-absence-card-date">
                                    Au {{ selectedAbsence.end_at | formatDate('DD MMMM YYYY') }} - {{
                                        selectedAbsence.end_moment == 1 ? 'matin' : 'après-midi' }} (inclus)
                                </div>

                                <div class="ix-absence-card-date mt-4">
                                    <span v-if="selectedAbsence.description">
                                        <p v-for="(line, index) in formattedDescription" :key="index">{{ line }}</p>
                                    </span>
                                </div>

                                <hr>

                                <div class="ix-absence-card-date mt-2" v-if="selectedAbsence.approved_at">
                                    Approuvée le {{ selectedAbsence.approved_at | formatDate('DD MMMM YYYY') }}
                                </div>
                                <div class="ix-absence-card-date" v-if="selectedAbsence.validated_at">
                                    Validée le {{ selectedAbsence.validated_at | formatDate('DD MMMM YYYY') }}
                                </div>

                            </div>

                            <div class="ix-absence-card-actions">
                                <button class="ix-btn ix-btn-block transparent mb-2" v-bind:disabled="loadingState"
                                    @click="state(selectedAbsence, 2)" v-if="selectedAbsence.state == 1 && canApprove"><i
                                        class="far fa-check"></i> Approuver</button>
                                <button class="ix-btn ix-btn-block transparent mb-2" v-bind:disabled="loadingState"
                                    @click="state(selectedAbsence, 3)"
                                    v-if="(selectedAbsence.state == 1 || selectedAbsence.state == 2) && canValid"><i
                                        class="far fa-check-double"></i> Valider</button>
                                <button class="ix-btn ix-btn-block transparent mb-2" v-bind:disabled="loadingState"
                                    @click="state(selectedAbsence, 4)"
                                    v-if="(selectedAbsence.state == 1 || selectedAbsence.state == 2) && (canApprove || canValid)"><i
                                        class="far fa-times"></i> Refuser</button>

                                <hr>

                                <button type="button" class="ix-btn ix-btn-block mb-2" v-if="selectedAbsence.is_editable"
                                    @click="editAbsence(selectedAbsence)">
                                    <i class="far fa-pen"></i> Modifier
                                </button>

                                <button type="button" class="ix-btn ix-btn-block" v-if="selectedAbsence.is_deletable"
                                    @click="deleteAbsence(selectedAbsence)" v-bind:disabled="loadingDelete">
                                    <span v-if="!loadingDelete"><i class="far fa-trash"></i> Supprimer</span>
                                    <span v-if="loadingDelete"><i class="far fa-circle-notch fa-spin"></i></span>
                                </button>
                            </div>

                        </div>
                    </div>

                    <div v-if="loadingShow">
                        <div class="modal-body">
                            <div class="ix-comments-loader">
                                <i class="far fa-circle-notch fa-spin"></i> Chargement des informations
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import Swal from "sweetalert2";

export default {
    name: "AbsencesTableModal",
    props: {
        admin: Number,
        url: String,
        usersUrl: String,
        auth: {},
        canApprove: Boolean,
        canValid: Boolean,
    },
    data() {
        return {
            loading: true,
            loadingForm: false,
            loadingDelete: false,
            loadingState: false,
            loadingShow: false,
            is_admin: this.admin || false,
            table: {
                days: [],
                weeks: [],
                months: [],
                data: []
            },
            form: this.fillForm(),
            types: [],
            selectedAbsence: null,
            selectedIndex: null,
            selectedUser: null,
        }
    },
    methods: {
        openAbsence() {
            var openShowButton = document.getElementById("openShow");
            var absenceData = openShowButton.getAttribute("data-absence");
            var absence = JSON.parse(absenceData);

            this.loadingShow = true
            this.selectedIndex = absence.id
            this.selectedUser = absence.user
            $('#showAbsenceModal').modal()

            fetch(this.url + '/' + absence.id, {
                ...this.getHttpJsonRequestHeaders(),
                ...{
                    method: "GET",
                }
            }).then((response) => {
                this.loadingShow = false
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.selectedAbsence = data
                    })
                } else {
                    $('#showAbsenceModal').modal('hide')
                }
            }).catch(error => {
                $('#showAbsenceModal').modal('hide')
                this.loadingShow = false
                console.log(error);
            })
        },
        async getData() {
            this.loading = true;
            fetch(this.url + window.location.search, {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                this.loading = false;
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.table.days = data.days
                        this.table.weeks = data.weeks
                        this.table.months = data.months
                        this.table.data = data.data
                        this.types = data.types
                    })
                }
            }).catch(error => {
                this.loading = false;
                console.log(error)
            });
        },
        openPostModal() {
            this.form = this.fillForm(null)
            $('#postAbsenceModal').modal()
        },
        editAbsence(selectedAbsence = null) {
            if (!selectedAbsence) {
                var editAbsenceButton = document.getElementById("editAbsenceModal");
                var absenceData = editAbsenceButton.getAttribute("data-absence");
                var absence = JSON.parse(absenceData);
            } else {
                var absence = selectedAbsence;
            }
            $('#showAbsenceModal').modal('hide');
            this.form = this.fillForm(absence)

            $('#postAbsenceModal').modal()
        },
        checkForm() {
            return (this.form.id == null ? (this.form.user != null) : true) && this.form.start_at && this.form.end_at && this.form.start_moment && this.form.end_moment
        },
        fillForm(absence = null) {
            let auth = JSON.parse(this.auth)

            return {
                id: absence ? absence.id : null,
                type: absence ? absence.type : 1,
                start_at: absence ? this.moment(absence.start_at).format('DD/MM/YYYY') : "",
                end_at: absence ? this.moment(absence.end_at).format('DD/MM/YYYY') : "",
                start_moment: absence ? absence.start_moment : 1,
                end_moment: absence ? absence.end_moment : 2,
                identity: absence ? null : auth.fullname,
                user: absence ? null : auth,
                exclude_saturdays: absence ? absence.exclude_saturdays : 1,
                exclude_sundays: absence ? absence.exclude_sundays : 1,
                exclude_public_holidays: absence ? absence.exclude_public_holidays : 1,
                description: absence ? absence.description : null,
            }
        },
        async post() {
            this.loadingForm = true

            var data = {
                type: this.form.type,
                start_at: this.form.start_at,
                end_at: this.form.end_at,
                start_moment: this.form.start_moment,
                end_moment: this.form.end_moment,
                exclude_saturdays: this.form.exclude_saturdays,
                exclude_sundays: this.form.exclude_sundays,
                exclude_public_holidays: this.form.exclude_public_holidays,
                description: this.form.description,
            }

            if (this.form.id == null) {
                data.user_id = this.form.user.id
            }

            fetch(this.url + (this.form.id ? '/' + this.form.id : ''), {
                ...this.getHttpJsonRequestHeaders(),
                ...{
                    method: this.form.id ? "PUT" : "POST",
                    body: JSON.stringify(data)
                }
            }).then((response) => {
                if (response.ok) {
                    response.json().then((data) => {
                        location.reload()
                    })
                }
            }).catch(error => {
                this.loadingForm = false;
                console.log(error);
            })
        },
        deleteAbsence: function (absence) {
            this.$swal({
                title: "Êtes vous sûr ?",
                text: "L'absence sera définitivement supprimée",
                icon: "warning",
                dangerMode: true,
                buttons: ["Annuler", "Supprimer"]
            }).then((willDo) => {
                if (willDo) {
                    this.loadingDelete = true

                    $('#showAbsenceModal').modal('hide');
                    this.loadingDelete = false
                    this.selectedAbsence = null
                    this.selectedIndex = null
                    this.selectedUser = null

                    fetch(this.url + "/" + absence.id, {
                        ...{
                            method: 'DELETE'
                        },
                        ...this.getHttpJsonRequestHeaders()
                    }).then(async (response) => {
                        if (response.ok) {
                            window.location.reload()
                        }
                    }).catch(error => {
                        console.log(error);
                    })

                }
            });
        },
        async state(absence, state) {
            Swal.fire({
                title: 'Êtes-vous sûr ?',
                text: "Vous ne pourrez pas revenir en arrière",
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Annuler',
                confirmButtonText: 'Confirmer',
                reverseButtons: true,
                heightAuto: false
            }).then((result) => {
                if (result.value) {
                    this.loadingState = true

                    this.loadingState = false
                    $('#showAbsenceModal').modal('hide');

                    fetch(this.url + '/' + absence.id + '/state', {
                        ...this.getHttpJsonRequestHeaders(),
                        ...{
                            method: "PUT",
                            body: JSON.stringify({ state: state })
                        }
                    }).then((response) => {
                        if (response.ok) {
                            window.location.reload()
                        }
                    }).catch(error => {
                        console.log(error);
                    })
                }
            })
        },
    },
    async mounted() {
        $('.datepicker').change(function () {
            $(this)[0].dispatchEvent(new Event('input'));
        });

        $("#identityAutocomplete").autocomplete({
            minLength: 2,
            source: (request, response) => {
                $.ajax({
                    url: this.usersUrl,
                    type: 'get',
                    dataType: 'json',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    data: { q: request.term },
                    success: (data) => {
                        response($.map(data, (item) => {
                            return Object.assign(item, {
                                label: item.fullname,
                                value: item.fullname,
                            })
                        }))
                    }
                });
            },
            change: (e, item) => {
                if (!item.item) {
                    this.form.identity = ""
                    this.form.user = null
                }
            },
            select: (e, item) => {
                this.form.identity = item.item.fullname
                this.form.user = item.item
            }
        }).focus(() => {
            $("#identityAutocomplete").autocomplete("search", '');
        });

        await this.getData();
    },
    computed: {
        formattedDescription() {
            return this.selectedAbsence.description.split('\n');
        }
    }
}
</script>